export default "__VITE_ASSET__CRsfhcmD__"